import { Text, View } from '@react-pdf/renderer';
import { isEmptyString } from '@weft/utils';
import React from 'react';

type FooterProps = {
  invoiceNotes?: string;
};

export const Notes: React.FC<FooterProps> = ({ invoiceNotes }) => {
  if (isEmptyString(invoiceNotes)) {
    return null;
  }

  return (
    <View style={{
      paddingTop: '6px',
      fontSize: '10px',
    }}
    >
      <Text
        style={{
          color: '#B0B0B0',
          fontWeight: 100,
          paddingBottom: '6px',
        }}
      >
        Term & Notes
      </Text>
      <Text style={{
        color:'#292D32',
      }}
      >
        {invoiceNotes}
      </Text>
    </View>
  );
};